// extracted by mini-css-extract-plugin
export default {"container":"Container_container__BqBCj","arrow":"Container_arrow__h7SkN","title":"Container_title__lnZgq"};